(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frequency-sculpture"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('frequency-skyline')) return;
  const clamp = (v, low = 0, high = 1) => Math.max(low, Math.min(high, v));
  const smooth = (a, b, value) => { const t = clamp((value - a) / (b - a)); return t * t * (3 - 2 * t); };
  const noise = value => { const n = Math.sin(value * 127.1 + 311.7) * 43758.5453; return n - Math.floor(n); };
  const phase = value => {
    const p = clamp(value), still = p >= .44 && p <= .56;
    return {
      progress: p, still,
      speed: p < .44 ? 1 - smooth(.28, .44, p) : smooth(.56, .72, p),
      camera: p < .44 ? smooth(0, .44, p) * .5 : p > .56 ? .5 + smooth(.56, 1, p) * .5 : .5,
      city: smooth(.02, .4, p) * (1 - smooth(.6, .99, p))
    };
  };
  const spectrum = (x, time) => {
    const bass = .5 + .5 * Math.sin(x * 13 - time * 1.3);
    const mid = .5 + .5 * Math.sin(x * 37 + time * 1.65);
    const high = .5 + .5 * Math.sin(x * 83 - time * 2.1);
    return clamp((.1 + .45 * bass * bass + .24 * mid * mid + .13 * high) * (.78 + .22 * Math.sin(x * 7 + time * .43)), .05, 1);
  };
  function line(path, x1, y1, x2, y2) { path.moveTo(x1, y1); path.lineTo(x2, y2); }
  function polygon(path, points) {
    points.forEach(([x,y], i) => i ? path.lineTo(x,y) : path.moveTo(x,y));
    path.closePath();
  }
  function tower(kind, x, ground, width, height) {
    const p = (u,v) => [x + u * width, ground - v * height];
    if (kind === 'world') return [p(0,0),p(.17,1),p(.83,1),p(1,0)];
    if (kind === 'empire') return [p(0,0),p(0,.65),p(.14,.65),p(.14,.81),p(.28,.81),p(.28,.94),p(.4,.94),p(.4,1),p(.6,1),p(.6,.94),p(.72,.94),p(.72,.81),p(.86,.81),p(.86,.65),p(1,.65),p(1,0)];
    if (kind === 'chrysler') return [p(0,0),p(0,.64),p(.14,.64),p(.14,.79),p(.25,.79),p(.5,1.06),p(.75,.79),p(.86,.79),p(.86,.64),p(1,.64),p(1,0)];
    return [p(0,0),p(0,.86),p(.13,.86),p(.13,1),p(.87,1),p(.87,.86),p(1,.86),p(1,0)];
  }
  function layer(kind, enter, exit, depth, ground) {
    return { kind, enter, exit, depth, ground, outline: new Path2D(), detail: new Path2D(), lights: new Path2D() };
  }
  function waterTank(part, x, roof, width, height) {
    const tank = width * .32, cx = x + width * .62, top = roof - height;
    const left = cx - tank * .5, right = cx + tank * .5;
    polygon(part.outline, [[left,top + height * .18],[cx,top],[right,top + height * .18],[right,roof - height * .22],[left,roof - height * .22]]);
    line(part.detail,left,top + height * .23,right,top + height * .23);
    line(part.detail,left + tank * .12,roof - height * .22,left,roof);
    line(part.detail,right - tank * .12,roof - height * .22,right,roof);
  }
  function brownstone(part, x, ground, width, height, seed) {
    const roof = ground - height, cornice = Math.max(1,width * .032);
    polygon(part.outline, [[x,ground],[x,roof],[x - cornice,roof],[x - cornice,roof - cornice],[x + width + cornice,roof - cornice],[x + width + cornice,roof],[x + width,roof],[x + width,ground]]);
    line(part.detail,x,roof + cornice * 2.4,x + width,roof + cornice * 2.4);
    const floors = 3, floorHeight = height / 3.55;
    for (let floor = 0; floor < floors; floor++) {
      const y = roof + floorHeight * (.48 + floor);
      for (let col = 0; col < 2; col++) {
        const wx = x + width * (.18 + col * .44), ww = width * .18, wh = floorHeight * .5;
        part.detail.moveTo(wx,y + wh); part.detail.lineTo(wx,y + ww * .2);
        part.detail.quadraticCurveTo(wx + ww * .5,y - ww * .1,wx + ww,y + ww * .2);
        part.detail.lineTo(wx + ww,y + wh); part.detail.closePath();
        if (noise(seed + floor * 13 + col) > .76) part.lights.rect(wx + 1,y + 1,Math.max(1,ww - 2),Math.max(1,wh - 2));
      }
    }
    part.detail.rect(x + width * .43,ground - floorHeight * .66,width * .17,floorHeight * .66);
  }
  function warehouse(part, x, ground, width, height, seed) {
    const roof = ground - height, lip = Math.max(1,width * .018);
    polygon(part.outline, [[x,ground],[x,roof],[x - lip,roof],[x - lip,roof - lip],[x + width + lip,roof - lip],[x + width + lip,roof],[x + width,roof],[x + width,ground]]);
    const rows = 3, columns = width < 65 ? 2 : 3, pad = width * .13, gap = width * .09;
    for (let row = 0; row < rows; row++) {
      const y = roof + height * (.14 + row * .275), wh = height * .145;
      for (let col = 0; col < columns; col++) {
        const ww = (width - pad * 2 - gap * (columns - 1)) / columns, wx = x + pad + col * (ww + gap);
        part.detail.rect(wx,y,ww,wh);
        if (noise(seed + row * 7 + col) > .82) part.lights.rect(wx + 1,y + 1,Math.max(1,ww - 2),Math.max(1,wh - 2));
      }
    }
    if (seed % 3 === 0) waterTank(part,x,roof,width,height * .23);
  }
  class FrequencySkyline extends HTMLElement {
    static phase(value) { return phase(value); }
    static spectrum(x,time) { return spectrum(x,time); }
    connectedCallback() {
      if (this.connected) return;
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas?.getContext('2d',{alpha:true});
      if (!this.context || typeof Path2D === 'undefined') return;
      this.connected = true;
      this.story = this.closest('.scroll-story');
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      this.visible = false; this.frame = 0; this.lastStamp = 0; this.clock = 0; this.progress = 0; this.scrollDirty = true;
      this.tick = this.tick.bind(this); this.sync = this.sync.bind(this); this.measure = this.measure.bind(this);
      this.onScroll = () => { this.scrollDirty = true; this.schedule(); };
      const options = {signal:this.controller.signal};
      window.addEventListener('scroll',this.onScroll,{...options,passive:true});
      document.addEventListener('visibilitychange',this.sync,options);
      this.preference.addEventListener?.('change',this.sync,options);
      this.pauseState = this.paused();
      this.motionObserver = new MutationObserver(() => {
        const next = this.paused();
        if (next !== this.pauseState) { this.pauseState = next; this.sync(); }
      });
      this.motionObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      if ('ResizeObserver' in window) { this.sizeObserver = new ResizeObserver(this.measure); this.sizeObserver.observe(this); }
      else window.addEventListener('resize',this.measure,{...options,passive:true});
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting); this.sync();
        },{rootMargin:'60px',threshold:0});
        this.visibilityObserver.observe(this);
      } else this.visible = true;
      this.measure();
    }
    paused() { return this.preference.matches || document.documentElement.classList.contains('motion-paused'); }
    schedule() {
      if (!this.frame && this.visible && !document.hidden && this.width) this.frame = requestAnimationFrame(this.tick);
    }
    sync() {
      cancelAnimationFrame(this.frame); this.frame = 0; this.lastStamp = 0; this.scrollDirty = true; this.schedule();
    }
    measure() {
      const box = this.getBoundingClientRect();
      if (box.width < 1 || box.height < 1) return;
      const small = box.width < 700, ratio = Math.min(window.devicePixelRatio || 1,small ? 1.4 : 1.6);
      if (this.width === box.width && this.height === box.height && this.ratio === ratio) return;
      this.width = box.width; this.height = box.height; this.small = small; this.ratio = ratio;
      this.canvas.width = Math.max(1,Math.round(this.width * ratio)); this.canvas.height = Math.max(1,Math.round(this.height * ratio));
      this.context.setTransform(ratio,0,0,ratio,0,0);
      const c = this.context, w = this.width, h = this.height;
      this.sheen = c.createLinearGradient(0,h * .1,w,h * .75);
      [[0,'#a8dbca'],[.28,'#d4f975'],[.53,'#e1eee2'],[.78,'#b8c4d7'],[1,'#97d7cc']].forEach(([stop,color]) => this.sheen.addColorStop(stop,color));
      this.barGlow = c.createLinearGradient(0,h * .35,0,h * .94);
      [[0,'#d4f97500'],[.35,'#b5ded449'],[.6,'#d4f97591'],[1,'#acbfd000']].forEach(([stop,color]) => this.barGlow.addColorStop(stop,color));
      this.haze = [0,1,2].map(i => {
        const x = w * (.16 + i * .34), y = h * .51, radius = Math.max(70,Math.min(w * .29,h * .78));
        const gradient = c.createRadialGradient(x,y,0,x,y,radius);
        gradient.addColorStop(0,i === 1 ? '#d4f97510' : '#b8ddd812'); gradient.addColorStop(1,'#b8ddd800');
        return gradient;
      });
      this.rays = Array.from({length:7},(_,i) => {
        const x = w * (i / 6), top = h * (.05 + noise(i + 3) * .17), end = x + (noise(i + 9) - .5) * w * .24;
        const gradient = c.createLinearGradient(x,h * .72,end,top);
        gradient.addColorStop(0,'#c7e8d324'); gradient.addColorStop(1,'#b8c4d700');
        return {x,top,end,gradient};
      });
      const segments = this.small ? 100 : Math.min(184,Math.round(w / 7));
      this.samples = Array.from({length:segments + 1},(_,i) => {
        const u = i / segments;
        return [u * w,.35 + .65 * Math.pow(Math.sin(Math.PI * u),2),Math.sin(u * 21),Math.cos(u * 21),Math.sin(u * 43),Math.cos(u * 43),Math.sin(u * 9),Math.cos(u * 9)];
      });
      this.buildCity(); this.sync();
    }
    buildCity() {
      const w = this.width, h = this.height;
      this.layers = [];
      for (let rear = 1; rear >= 0; rear--) {
        const part = layer('manhattan',rear ? .025 : .055,rear ? .77 : .72,rear ? .24 : .5,h * (rear ? .645 : .67));
        const count = this.small ? (rear ? 25 : 19) : (rear ? 38 : 29), cell = w / count;
        for (let i = -1; i <= count; i++) {
          const seed = i + (rear ? 83 : 17), landmark = !rear && [Math.round(count * .29),Math.round(count * .58),Math.round(count * .73)].indexOf(i);
          const kind = landmark === 0 ? 'world' : landmark === 1 ? 'empire' : landmark === 2 ? 'chrysler' : 'block';
          const width = cell * (.65 + noise(seed) * .27), x = i * cell;
          const height = h * (kind !== 'block' ? (kind === 'world' ? .46 : .41) : .14 + noise(seed + 10) * .19) * (rear ? .65 : 1);
          const points = tower(kind,x,part.ground,width,height);
          polygon(part.outline,points);
          if (!rear) {
            const dx = Math.min(8,cell * .14), roof = points.slice(1,-1);
            roof.forEach(([px,py],j) => { if (j) line(part.detail,roof[j - 1][0] + dx,roof[j - 1][1] - dx,px + dx,py - dx); if (!(j % 3)) line(part.detail,px,py,px + dx,py - dx); });
            for (let row = 1; row < (kind === 'block' ? 6 : 11); row++) {
              const y = part.ground - height * row / (kind === 'block' ? 8 : 16);
              line(part.detail,x + width * .18,y,x + width * .82,y);
              if (noise(seed + row) > .6) part.lights.rect(x + width * .27,y - 2,Math.max(1,width * .14),2);
            }
            if (kind !== 'block') line(part.detail,x + width * .5,part.ground - height * (kind === 'chrysler' ? 1.06 : 1),x + width * .5,part.ground - height * 1.23);
          }
        }
        this.layers.push(part);
      }
      const bridge = layer('bridge',.14,.68,.65,h * .755), g = bridge.ground;
      const left = w * .39, right = w * .64, top = h * .49, tw = Math.max(12,w * .017);
      for (const x of [left,right]) {
        polygon(bridge.outline,[[x - tw,g],[x - tw,top],[x + tw,top],[x + tw,g]]);
        for (let arch = 0; arch < 2; arch++) {
          const ax = x - tw * .7 + arch * tw * .78, aw = tw * .6;
          bridge.detail.moveTo(ax,g); bridge.detail.lineTo(ax,top + h * .075);
          bridge.detail.lineTo(ax + aw * .5,top + h * .04); bridge.detail.lineTo(ax + aw,top + h * .075); bridge.detail.lineTo(ax + aw,g);
        }
      }
      line(bridge.detail,w * .25,g,w * .8,g); line(bridge.detail,w * .25,g + 4,w * .8,g + 4);
      bridge.detail.moveTo(w * .25,g - h * .065); bridge.detail.quadraticCurveTo(w * .33,g - h * .07,left,top + 4);
      bridge.detail.quadraticCurveTo((left + right) * .5,g + h * .08,right,top + 4);
      bridge.detail.quadraticCurveTo(w * .73,g - h * .07,w * .8,g - h * .065);
      for (let i = 1; i < 16; i++) {
        const u = i / 16, x = left + (right - left) * u;
        const y = (1 - u) * (1 - u) * (top + 4) + 2 * (1 - u) * u * (g + h * .08) + u * u * (top + 4);
        line(bridge.detail,x,y,x,g);
      }
      this.layers.push(bridge);
      const brooklyn = layer('brooklyn',.02,.6,0,h * .78);
      const districts = [[-.01,.30,0],[.31,.425,1],[.63,.765,1],[.775,1.01,0]];
      districts.forEach(([start,end,loft],index) => {
        const span = w * (end - start), target = loft ? (this.small ? 64 : 102) : (this.small ? 34 : 53);
        const count = Math.max(1,Math.round(span / target)), cell = span / count;
        for (let i = 0; i < count; i++) {
          const seed = index * 13 + i + 11, width = cell * .94, x = start * w + i * cell;
          const profile = .98 + noise(seed) * .045;
          const height = Math.min(h * (loft ? .165 : .135),width * (loft ? 1.16 : 1.8)) * profile;
          if (loft) warehouse(brooklyn,x,brooklyn.ground,width,height,seed);
          else brownstone(brooklyn,x,brooklyn.ground,width,height,seed);
        }
      });
      this.layers.push(brooklyn);
    }

    tick(stamp) {
      this.frame = 0;
      if (!this.visible || document.hidden || !this.width) { this.lastStamp = 0; return; }
      if (this.scrollDirty) {
        const box = this.story?.getBoundingClientRect();
        this.progress = this.paused() ? .5 : box ? clamp(-box.top / Math.max(1,box.height - window.innerHeight)) : .5;
        this.scrollDirty = false;
      }
      const state = phase(this.progress), stopped = this.paused() || state.still;
      const delta = this.lastStamp ? stamp - this.lastStamp : 0, interval = 1000 / (this.small ? 24 : 30);
      if (!this.lastStamp || delta >= interval - .5 || stopped) {
        this.clock += Math.min(delta,80) * state.speed / 1000;
        this.lastStamp = stamp;
        this.paint(state);
        this.classList.toggle('is-city-still',stopped);
      }
      if (!stopped) this.schedule(); else this.lastStamp = 0;
    }
    drawDistrict(part,state,front) {
      const foreground = part.kind === 'brooklyn';
      if (foreground !== front) return;
      const amount = state.city;
      if (amount < .002) return;
      const c = this.context, quiet = state.city;
      c.save();
      if (part.kind === 'manhattan') c.translate((state.camera - .5) * 24 * part.depth,0);
      c.globalCompositeOperation = 'source-over'; c.globalAlpha = amount * (foreground ? .8 : .6); c.fillStyle = '#0b140f'; c.fill(part.outline);
      c.globalCompositeOperation = 'screen'; c.strokeStyle = this.sheen;
      const opacity = foreground ? .32 + quiet * .13 : part.kind === 'bridge' ? .24 + quiet * .1 : part.depth < .3 ? .18 : .32 + quiet * .16;
      c.globalAlpha = amount * opacity; c.lineWidth = foreground ? .65 : .7; c.stroke(part.outline);
      c.globalAlpha = amount * opacity * (foreground ? .47 : .48); c.lineWidth = .5; c.stroke(part.detail);
      c.globalAlpha = amount * (foreground ? .035 + quiet * .025 : .1); c.fillStyle = '#e1efc1'; c.fill(part.lights);
      c.restore();
    }
    paint(state) {
      const c = this.context, w = this.width, h = this.height, time = this.clock, base = h * .725;
      c.clearRect(0,0,w,h); c.lineCap = 'round'; c.lineJoin = 'round'; c.globalCompositeOperation = 'source-over';
      for (const glow of this.haze) { c.fillStyle = glow; c.globalAlpha = .65 + state.city * .35; c.fillRect(0,0,w,h); }
      c.globalCompositeOperation = 'screen';
      this.rays.forEach((ray,i) => {
        c.save(); c.translate(Math.sin(time * .14 + i) * w * .012,0);
        c.globalAlpha = .36 + state.city * .1; c.strokeStyle = ray.gradient; c.lineWidth = i % 3 ? .6 : 1;
        c.beginPath(); c.moveTo(ray.x,base); c.lineTo(ray.end,ray.top); c.stroke(); c.restore();
      });
      for (const part of this.layers) this.drawDistrict(part,state,false);
      c.globalCompositeOperation = 'screen';
      const bars = this.small ? 66 : Math.min(174,Math.round(w / 8)), gap = w / bars, quiet = 1 - state.city * .52;
      c.lineCap = 'butt';
      for (let i = 0; i <= bars; i++) {
        const x = i * gap, value = spectrum(i / bars,time), amplitude = h * (.025 + .2 * value);
        c.globalAlpha = (.27 + value * .3) * quiet; c.strokeStyle = this.barGlow; c.lineWidth = Math.max(1.2,gap * .38);
        c.beginPath(); c.moveTo(x,base - amplitude); c.lineTo(x,base + amplitude * .37); c.stroke();
        c.globalAlpha = (.4 + value * .3) * quiet; c.strokeStyle = this.sheen; c.lineWidth = Math.max(.7,gap * .1);
        c.beginPath(); c.moveTo(x,base - amplitude); c.lineTo(x,base + amplitude * .35); c.stroke();
      }
      const strands = this.small ? 12 : 19;
      c.lineCap = 'round'; c.strokeStyle = this.sheen;
      for (let row = 0; row < strands; row++) {
        const plane = row / (strands - 1), offset = (plane - .5) * h * .095, amplitude = h * (.045 + .025 * Math.sin(plane * Math.PI));
        const a = -time * 1.1 + row * .13, b = time * .69 + row * .065, d = time * .37;
        const sa = Math.sin(a), ca = Math.cos(a), sb = Math.sin(b), cb = Math.cos(b), sd = Math.sin(d), cd = Math.cos(d);
        c.globalAlpha = (.11 + .22 * Math.pow(Math.sin(plane * Math.PI),2)) * (1 - state.city * .23);
        c.lineWidth = row % 6 ? .55 : 1.05; c.beginPath();
        for (let i = 0; i < this.samples.length; i++) {
          const [x,envelope,s1,c1,s2,c2,s3,c3] = this.samples[i];
          const signal = envelope * ((s1 * ca + c1 * sa) * .58 + (s2 * cb + c2 * sb) * .27 + (s3 * cd + c3 * sd) * .15);
          const y = base + offset + signal * amplitude;
          if (!i) c.moveTo(x,y); else c.lineTo(x,y);
        }
        c.stroke();
      }
      for (const part of this.layers) this.drawDistrict(part,state,true);
      c.globalCompositeOperation = 'screen'; c.strokeStyle = this.sheen;
      for (let row = 0; row < 5; row++) {
        const depth = row / 4, y = base + h * (.085 + depth * depth * .17);
        c.globalAlpha = (1 - depth) * .09; c.lineWidth = .5; c.beginPath();
        c.moveTo(0,y); c.bezierCurveTo(w * .33,y + Math.sin(time * .45 + row) * 3,w * .66,y - Math.cos(time * .31 + row) * 3,w,y); c.stroke();
      }
      c.globalAlpha = .32; c.lineWidth = .7; c.beginPath(); c.moveTo(0,base); c.lineTo(w,base); c.stroke();
      for (let i = 0; i < (this.small ? 4 : 7); i++) {
        const u = (time * .018 + i * .147) % 1, x = u * w, y = base + Math.sin(u * 21 - time * 1.1) * h * .035;
        c.fillStyle = '#e8f6cf'; c.globalAlpha = .55; c.beginPath(); c.arc(x,y,1.15,0,Math.PI * 2); c.fill();
        c.globalAlpha = .06; c.beginPath(); c.arc(x,y,4.5,0,Math.PI * 2); c.fill();
      }
      c.globalAlpha = 1; c.globalCompositeOperation = 'source-over'; this.classList.add('is-ready');
    }
    disconnectedCallback() {
      this.connected = false; cancelAnimationFrame(this.frame); this.controller?.abort();
      this.sizeObserver?.disconnect(); this.visibilityObserver?.disconnect(); this.motionObserver?.disconnect();
    }
  }
  customElements.define('frequency-skyline',FrequencySkyline);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["production-word"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('production-spotlight')) return;
  const BASE_DURATION = 10000 / 1.32;
  const REVEAL_START = .06;
  const REVEAL_END = .29;
  const HOLD_END = .70;
  const REST_MS = BASE_DURATION * REVEAL_START;
  const REVEAL_MS = BASE_DURATION * (REVEAL_END - REVEAL_START) / 1.44;
  const HOLD_MS = 2000;
  const SMOKE_STRETCH = 1.2;
  const SMOKE_STRENGTH = 3;
  const SMOKE_SCALE = 2;
  const DURATION = REST_MS + REVEAL_MS + HOLD_MS + BASE_DURATION * (1 - HOLD_END) * SMOKE_STRETCH;
  function timelineTime(progress) {
    if (progress <= REVEAL_START) return progress * BASE_DURATION;
    if (progress <= REVEAL_END) return REST_MS + (progress - REVEAL_START) / (REVEAL_END - REVEAL_START) * REVEAL_MS;
    if (progress <= HOLD_END) return REST_MS + REVEAL_MS + (progress - REVEAL_END) / (HOLD_END - REVEAL_END) * HOLD_MS;
    return REST_MS + REVEAL_MS + HOLD_MS + (progress - HOLD_END) * BASE_DURATION * SMOKE_STRETCH;
  }
  function timelineOffset(offset) { return 1 - timelineTime(1 - offset) / DURATION; }
  function logicalProgress(milliseconds) {
    const time = ((milliseconds % DURATION) + DURATION) % DURATION;
    if (time <= REST_MS) return time / BASE_DURATION;
    if (time <= REST_MS + REVEAL_MS) return REVEAL_START + (time - REST_MS) / REVEAL_MS * (REVEAL_END - REVEAL_START);
    if (time <= REST_MS + REVEAL_MS + HOLD_MS) return REVEAL_END + (time - REST_MS - REVEAL_MS) / HOLD_MS * (HOLD_END - REVEAL_END);
    return HOLD_END + (time - REST_MS - REVEAL_MS - HOLD_MS) / (BASE_DURATION * SMOKE_STRETCH);
  }
  const POOF_START = .70;
  const POOF_FADE = .08;
  const POOF_STAGGER = 0;
  const POOF_END = .99;
  const TAU = Math.PI * 2;
  const clamp = value => Math.max(0,Math.min(1,value));
  const smooth = (a,b,value) => {const x=clamp((value-a)/(b-a)); return x*x*(3-2*x);};
  function letterStart(index,count) {
    return POOF_START + POOF_STAGGER * index / Math.max(1,count-1);
  }
  function letterFrames(index,count) {
    const start=letterStart(index,count);
    return [
      {offset:0,opacity:0,transform:'translate(0,0)',easing:'linear'},
      {offset:1-start-POOF_FADE,opacity:0,transform:'translate(0,0)',easing:'cubic-bezier(.333333,0,.666667,1)'},
      {offset:1-start,opacity:1,transform:'translate(0,0)',easing:'linear'},
      {offset:1,opacity:1,transform:'translate(0,0)',easing:'linear'}
    ].map(frame=>({...frame,offset:timelineOffset(frame.offset)}));
  }
  function wordFrames() {
    return [
      {offset:0,opacity:0,maskPosition:'0% 0%',transform:'translate(0,0)',easing:'linear'},
      {offset:1-POOF_END,opacity:0,maskPosition:'0% 0%',transform:'translate(0,0)',easing:'linear'},
      {offset:1-POOF_START-POOF_STAGGER-POOF_FADE,opacity:1,maskPosition:'0% 0%',transform:'translate(0,0)',easing:'linear'},
      {offset:1-(REVEAL_START+(REVEAL_END-REVEAL_START)/1.44),opacity:1,maskPosition:'0% 0%',transform:'translate(0,0)',easing:'ease-in-out'},
      {offset:.94,opacity:0,maskPosition:'100% 0%',transform:'translate(0,0)',easing:'linear'},
      {offset:1,opacity:0,maskPosition:'100% 0%',transform:'translate(0,0)'}
    ].map(frame => ({...frame,offset:timelineOffset(frame.offset)}));
  }
  function breathPulse(progress) {
    const time=progress>=.84?progress:progress+1;
    if(time<=1.06){
      return (1-Math.cos(Math.PI*clamp((time-.84)/.22)))*.5;
    }
    return (1+Math.cos(Math.PI*clamp((time-1.06)/.16)))*.5;
  }
  function breathFrames(glow = false) {
    const offsets=[0,.16,.78,.94,1];
    for(let i=1;i<24;i++){
      offsets.push(.16*i/24,.78+.16*i/24,.94+.06*i/24);
    }
    return offsets.sort((a,b)=>a-b).map(offset=>({
      offset:timelineOffset(offset),
      ...(glow ? {opacity:.68*breathPulse(1-offset)} : {transform:'scale('+(1+.035*breathPulse(1-offset))+')'}),
      easing:'linear'
    }));
  }
  function scene(milliseconds) {
    const progress = logicalProgress(milliseconds);
    const phase = 1-progress;
    const stage = progress>=POOF_END?'rest':progress>=POOF_START+POOF_STAGGER+POOF_FADE?'smoke':progress>=POOF_START?'dissolve':phase>=.285&&phase<.71?'hold':phase>=.71&&phase<.94?'reveal':'rest';
    return {
      phase,
      direction:'reverse',
      breath:progress>=.84?'inhale':progress<.06?'inhale-hold':progress<.29?'exhale':'rest',
      reveal:clamp((phase-.115)/.15),
      dissolve:smooth(.71,.94,phase),
      exit:smooth(.72,.92,phase),
      exitSmoke:smooth(.70,.75,phase)*(1-smooth(.88,.99,phase)),
      envelope:smooth(.015,.08,phase)*(1-smooth(.88,.99,phase)),
      beam:1-smooth(.28,.40,phase),
      stage
    };
  }
  class ProductionSpotlight extends HTMLElement {
    static timing() { return {cycleMs:DURATION,revealMs:REVEAL_MS,holdMs:HOLD_MS}; }
    static letterFrames(index,count) {return letterFrames(index,count);}
    static breathFrames() {return breathFrames();}
    static breathPulse(progress) {return breathPulse(progress);}
    static scene(milliseconds) {return scene(milliseconds);}
    static wordFrames() {return wordFrames();}
    connectedCallback() {
      if (this.connected) return;
      this.canvas=this.querySelector('canvas');
      this.context=this.canvas?.getContext('2d',{alpha:true});
      this.word=this.closest('.production-word');
      this.brandHeading=this.word?.closest('h1');
      this.brandName=this.brandHeading?.querySelector('.brand-breathing-name');
      this.brandGlow=this.brandName?.querySelector('.brand-name-glow');
      this.lettering=this.word?.querySelector('.production-lettering');
      this.letters=[...this.word?.querySelectorAll('.production-letter')||[]];
      if (!this.context||!this.lettering||!this.letters.length||typeof this.letters[0].animate!=='function') return;
      this.connected=true;
      this.controller=new AbortController();
      this.preference=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible=false;
      this.elapsed=timelineTime(POOF_START);
      this.frame=0;
      this.lastStamp=0;
      const glyphs=this.letters.filter(letter=>(letter.dataset.letter || letter.textContent).trim());
      this.effects=this.letters.map(letter=>{
        const index=Math.max(0,glyphs.indexOf(letter));
        const effect=letter.animate(letterFrames(index,glyphs.length),{duration:DURATION,iterations:Infinity,direction:'reverse',fill:'both'});
        effect.pause();
        effect.currentTime=this.elapsed;
        return effect;
      });
      const dissolve=this.lettering.animate(wordFrames(),{duration:DURATION,iterations:Infinity,direction:'reverse',fill:'both'});
      dissolve.pause();
      dissolve.currentTime=this.elapsed;
      this.effects.push(dissolve);
      if(this.brandName){
        const breath=this.brandName.animate(breathFrames(),{duration:DURATION,iterations:Infinity,direction:'reverse',fill:'both'});
        breath.pause();
        breath.currentTime=this.elapsed;
        this.effects.push(breath);
        if(this.brandGlow){
          const glowFrames=breathFrames(true);
          const glow=this.brandGlow.animate(glowFrames,{duration:DURATION,iterations:Infinity,direction:'reverse',fill:'both'});
          glow.pause();
          glow.currentTime=this.elapsed;
          this.effects.push(glow);
        }
      }
      this.tick=this.tick.bind(this);
      this.sync=this.sync.bind(this);
      this.measure=this.measure.bind(this);
      const options={signal:this.controller.signal};
      document.addEventListener('visibilitychange',this.sync,options);
      this.preference.addEventListener?.('change',this.sync,options);
      this.pauseState=this.paused();
      this.motionObserver=new MutationObserver(()=>{
        const next=this.paused();
        if(next!==this.pauseState){this.pauseState=next;this.sync();}
      });
      this.motionObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      if('ResizeObserver' in window){
        this.sizeObserver=new ResizeObserver(this.measure);
        this.sizeObserver.observe(this);
      }else window.addEventListener('resize',this.measure,options);
      if('IntersectionObserver' in window){
        this.visibilityObserver=new IntersectionObserver(entries=>{
          this.visible=entries.some(entry=>entry.isIntersecting);
          this.sync();
        },{rootMargin:'50px',threshold:0});
        this.visibilityObserver.observe(this);
      }else this.visible=true;
      this.measure();
      document.fonts?.ready.then(()=>{if(this.connected)this.measure();});
    }
    paused(){return this.preference.matches||document.documentElement.classList.contains('motion-paused');}
    measure(){
      const wordBox=this.word.getBoundingClientRect();
      const box=this.getBoundingClientRect();
      if(box.width<1||box.height<1)return;
      this.width=box.width;
      this.height=box.height;
      this.wordY=wordBox.top+wordBox.height*.5-box.top;
      this.small=window.innerWidth<700;
      const ratio=Math.min(window.devicePixelRatio||1,this.small?1.5:1.75);
      this.canvas.width=Math.max(1,Math.round(this.width*ratio));
      this.canvas.height=Math.max(1,Math.round(this.height*ratio));
      this.context.setTransform(ratio,0,0,ratio,0,0);
      const first=this.letters[0].getBoundingClientRect();
      const last=this.letters[this.letters.length-1].getBoundingClientRect();
      this.firstX=first.left+first.width*.5-box.left;
      this.lastX=last.left+last.width*.5-box.left;
      this.traceLetters(box);
      this.sheen='#f0f1e9';
      this.sync();
    }
    traceLetters(box){
      const mask=document.createElement('canvas');
      const ink=mask.getContext('2d',{willReadFrequently:true});
      const letters=this.letters.filter(letter=>(letter.dataset.letter || letter.textContent).trim());
      this.smokeLetters=letters.map((letter,index)=>{
        const rect=letter.getBoundingClientRect();
        const style=getComputedStyle(letter);
        const fontSize=parseFloat(style.fontSize)||24;
        const fallback={x:rect.left+rect.width*.5-box.left,y:rect.top+rect.height*.5-box.top};
        const glyph={start:letterStart(index,letters.length),center:fallback,width:rect.width,height:rect.height,points:[fallback]};
        if(!ink)return glyph;
        const font=style.fontStyle+' '+style.fontWeight+' '+style.fontSize+' '+style.fontFamily;
        ink.font=font;
        const text=(letter.dataset.letter || letter.textContent).trim();
        const metrics=ink.measureText(text);
        const ascent=metrics.actualBoundingBoxAscent||fontSize*.75;
        const descent=metrics.actualBoundingBoxDescent||0;
        const left=metrics.actualBoundingBoxLeft||0;
        const right=metrics.actualBoundingBoxRight||metrics.width;
        const padding=3;
        mask.width=Math.max(1,Math.ceil(left+right)+padding*2);
        mask.height=Math.max(1,Math.ceil(ascent+descent)+padding*2);
        ink.font=font;
        ink.fillStyle='#fff';
        ink.fillText(text,padding+left,padding+ascent);
        const pixels=ink.getImageData(0,0,mask.width,mask.height).data;
        const fontAscent=metrics.fontBoundingBoxAscent||fontSize*.8;
        const fontDescent=metrics.fontBoundingBoxDescent||fontSize*.2;
        const baseline=rect.top+(rect.height-fontAscent-fontDescent)*.5+fontAscent-box.top;
        const originX=rect.left+(rect.width-metrics.width)*.5-left-box.left;
        const candidates=[];
        for(let y=padding;y<mask.height-padding;y+=2){
          for(let x=padding;x<mask.width-padding;x+=2){
            if(pixels[(y*mask.width+x)*4+3]>96)candidates.push({x:originX+x-padding,y:baseline-ascent+y-padding});
          }
        }
        if(!candidates.length)return glyph;
        const count=Math.min(candidates.length,this.small?5:7);
        glyph.points=Array.from({length:count},(_,point)=>candidates[Math.min(candidates.length-1,Math.floor((point+.5)*candidates.length/count))]);
        glyph.width=left+right;
        glyph.height=ascent+descent;
        glyph.center={x:originX+(left+right)*.5,y:baseline+(descent-ascent)*.5};
        return glyph;
      });
    }
    sync(){
      cancelAnimationFrame(this.frame);
      this.frame=0;
      this.lastStamp=0;
      const current=this.effects[0]?.currentTime;
      if(typeof current==='number')this.elapsed=current;
      this.effects.forEach(effect=>effect.pause());
      if(this.preference.matches){
        this.elapsed=DURATION*.5;
        this.effects.forEach(effect=>{effect.currentTime=this.elapsed;});
      }
      if(!this.width||!this.visible||document.hidden)return;
      this.paint();
      if(this.paused())return;
      const start=document.timeline.currentTime;
      this.effects.forEach(effect=>{
        effect.currentTime=this.elapsed;
        effect.play();
        if(typeof start==='number')effect.startTime=start-this.elapsed;
      });
      this.frame=requestAnimationFrame(this.tick);
    }
    tick(stamp){
      this.frame=0;
      if(!this.visible||document.hidden||this.paused()){this.sync();return;}
      const interval=this.small?1000/24:1000/30;
      if(!this.lastStamp)this.lastStamp=stamp;
      if(stamp-this.lastStamp>=interval-.5){
        this.lastStamp=stamp;
        const current=this.effects[0]?.currentTime;
        if(typeof current==='number')this.elapsed=current;
        this.paint();
      }
      this.frame=requestAnimationFrame(this.tick);
    }
    mist(x,y,rx,ry,alpha){
      if(alpha<.001)return;
      const c=this.context;
      c.save();
      c.translate(x,y);
      c.scale(rx,ry);
      const glow=c.createRadialGradient(0,0,0,0,0,1);
      glow.addColorStop(0,'#f0f1e9');
      glow.addColorStop(.26,'#f6f8f088');
      glow.addColorStop(.65,'#f6f8f020');
      glow.addColorStop(1,'#f0f1e900');
      c.fillStyle=glow;
      c.globalAlpha=alpha;
      c.fillRect(-1,-1,2,2);
      c.restore();
    }
    paintPoof(progress){
      for(const [index,glyph] of (this.smokeLetters||[]).entries()){
        const release=clamp((progress-glyph.start)/(POOF_END-glyph.start));
        const envelope=smooth(glyph.start,glyph.start+POOF_FADE*.8,progress)*(1-smooth(.24,.98,release));
        if(envelope<.001)continue;
        const bloom=smooth(0,.86,release);
        const cloudSize=1+(SMOKE_SCALE-1)*smooth(glyph.start,glyph.start+POOF_FADE,progress);
        const lift=Math.min(8,glyph.height*.35)*smooth(.12,.9,release);
        const strength=envelope*.09*SMOKE_STRENGTH*Math.sqrt(6/glyph.points.length);
        this.mist(glyph.center.x,glyph.center.y-lift,(glyph.width*.48+bloom*5)*cloudSize,(glyph.height*.4+bloom*6)*cloudSize,envelope*.012*SMOKE_STRENGTH);
        glyph.points.forEach((point,i)=>{
          const size=(.86+.28*Math.pow(Math.sin((index+1)*2.17+i*1.91),2))*cloudSize;
          this.mist(point.x,point.y-lift,(2.8+bloom*7)*size,(2.8+bloom*8)*size,strength);
        });
      }
    }
    paint(){
      const c=this.context,w=this.width,h=this.height;
      if(!c||!w||!h)return;
      const state=scene(this.elapsed);
      const progress=1-state.phase;
      if(this.getAttribute('data-stage')!==state.stage)this.setAttribute('data-stage',state.stage);
      if(this.getAttribute('data-direction')!==state.direction)this.setAttribute('data-direction',state.direction);
      if(this.getAttribute('data-breath')!==state.breath)this.setAttribute('data-breath',state.breath);
      c.clearRect(0,0,w,h);
      c.globalCompositeOperation='screen';
      const time=state.phase*10;
      const y=this.wordY??h-32;
      const band=this.small?62:68;
      const first=this.firstX??w*.08,last=this.lastX??w*.92;
      const vanishing=progress>=POOF_START&&!this.preference.matches;
      if(vanishing){
        c.globalCompositeOperation='source-over';
        this.paintPoof(progress);
        c.globalAlpha=1;
        c.globalCompositeOperation='source-over';
        this.classList.add('is-ready');
        return;
      }
      const handoff=this.preference.matches?1:1-smooth(REVEAL_END+.04,REVEAL_END+.14,progress);
      if(handoff>.001){
        const head=first+(last-first)*state.reveal;
        const exitHead=last-(last-first)*state.exit;
        const envelope=(this.preference.matches ? .12 : state.envelope)*handoff;
        const clouds=this.small?18:26;
        for(let i=0;i<clouds;i++){
          const u=i/Math.max(1,clouds-1);
          const coverage=smooth(u-.18,u+.04,state.reveal);
          const leaving=smooth(.66+(1-u)*.06,.90+(1-u)*.06,state.phase);
          const curl=Math.sin(i*1.73+time*.55);
          const x=first+(last-first)*u+curl*(3+leaving*5);
          const puffY=y+Math.sin(u*TAU*1.6-time*.42)*4+curl*2;
          const alpha=envelope*coverage*(.05+state.beam*.055+leaving*.06);
          const radius=20+Math.sin(i*.91+time*.22)*7+leaving*8;
          this.mist(x,puffY,radius,9+Math.cos(i*.7)*3,alpha);
          this.mist(x+Math.cos(i*1.9)*8,puffY-3-curl*2,radius*.8,7+Math.sin(i)*2,alpha*.6);
        }
        c.strokeStyle=this.sheen;
        c.lineCap='round';
        c.lineWidth=.65;
        const lines=this.small?6:9;
        for(let row=0;row<lines;row++){
          c.globalAlpha=envelope*(.03+state.dissolve*.035);
          c.beginPath();
          for(let step=0;step<=70;step++){
            const u=step/70;
            const visible=u*state.reveal;
            const x=first+(last-first)*visible;
            const edge=Math.sin(u*Math.PI);
            const drift=Math.sin(visible*TAU*1.3-time*.45+row*.16)*5;
            const py=y+drift+(row/(lines-1)-.5)*band*.29*edge;
            if(!step)c.moveTo(x,py);else c.lineTo(x,py);
          }
          c.stroke();
        }
        const beam=envelope*state.beam;
        const outgoing=envelope*state.exitSmoke;
        const radius=this.small?25:33;
        const beamX=head;
        const beamY=y;
        for(let i=0;i<9;i++){
          const u=i/8;
          const curl=Math.sin(i*1.47+time*.7);
          const spread=8+u*8;
          const alpha=1-u*.72;
          this.mist(beamX-u*radius*.9+curl*4,beamY+curl*spread*.3,18+u*13,8+u*5,beam*alpha*.17);
          this.mist(exitHead+u*radius*1.1+curl*4,y+curl*spread*.3,19+u*15,9+u*5,outgoing*alpha*.21);
        }
        this.mist(beamX,beamY,radius*1.5,17,beam*.08);
        this.mist(beamX,beamY,radius,11,beam*.24);
        this.mist(exitHead,y-2,radius*1.4,17,outgoing*.12);
      }
      c.globalAlpha=1;
      c.globalCompositeOperation='source-over';
      this.classList.add('is-ready');
    }
    disconnectedCallback(){
      this.connected=false;
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.effects?.forEach(effect=>effect.cancel());
      this.sizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.motionObserver?.disconnect();
    }
  }
  customElements.define('production-spotlight',ProductionSpotlight);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-page-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  if(!(event.target instanceof Element))return;
  document.querySelectorAll('details[data-page-menu][open]').forEach(menu=>{
    if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;
  });
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('details[data-page-menu][open]').forEach(menu=>{
    const restore=menu.contains(document.activeElement);
    menu.open=false;
    if(restore)menu.querySelector('summary')?.focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
